<template>
  <div>
    <div id="close-panel">
      <h4>If you return to the home screen you will lose your existing responses. Are you sure you want to continue?</h4>
      <router-link :to="{ name: 'home' }"><div class="m-btn m-btn__primary">Start Again!</div></router-link>
      <div class="nav-close" @click="$emit('close')"><div class="m-btn__cross"></div></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SimpleConfirmReset'
}
</script>

<style scoped lang="scss">
#close-panel {
    background:rgba(33,33,33,0.9);
    width:70%;
    height:275px;
    top:100px;
    left:15%;
    position:absolute;
    z-index:1005;
    padding:50px 25px;
    color:#fff;
  }
.nav-close {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.m-btn {
  background: #fff;
  &:hover {
    background: #f2f2f2;
  }
}

ul {
  margin: 0;
}

@media (max-width: 899px) {
  #close-panel {
      height:175px;
      top:50px;
      padding:30px 25px;
      h4 {font-size:125%;}
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SimpleConfirmReset.vue